// user/* page translations
const user = {
  notice: {
    filter: {
      category: 'Category',
      status: 'Status',
      all: 'All',
      categories: {
        system: 'System',
        equipment: 'Equipment',
        quality: 'Quality',
        alert: 'Alert Settings',
        education: 'Education',
        general: 'General',
      },
      statuses: {
        active: 'Published',
        waiting: 'Waiting',
        scheduled: 'Scheduled',
        inactive: 'Inactive',
        ended: 'Ended',
      },
    },
    searchPlaceholder: 'Search title or content',
    addBtn: 'Register Notice',
    col: {
      category: 'Category',
      startDate: 'Start Date',
      endDate: 'End Date',
      title: 'Title',
      author: 'Author',
      priority: 'Priority',
      status: 'Status',
      views: 'Views',
      createdAt: 'Created',
      action: 'Action',
    },
    priority: {
      high: 'High',
      normal: 'Normal',
      low: 'Low',
    },
    addModal: {
      title: 'Register Notice',
    },
    editModal: {
      title: 'Edit Notice',
    },
    form: {
      titleLabel: 'Title',
      titlePlaceholder: 'Enter notice title',
      categoryLabel: 'Category',
      priorityLabel: 'Priority',
      pinnedLabel: 'Pin to Top',
      pinnedHint: 'Show notice in header',
      startDateLabel: 'Publish Start Date',
      endDateLabel: 'Publish End Date',
      contentLabel: 'Content',
      contentPlaceholder: 'Enter notice content',
    },
    actions: {
      register: 'Register',
      cancel: 'Cancel',
      update: 'Update',
      delete: 'Delete',
    },
    seed: {
      defaultCategory: 'Notice',
      defaultAuthor: 'Administrator',
    },
    deleteModal: {
      title: 'Delete Notice',
      message: 'Are you sure you want to delete "{title}"?\nThis action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    alertDeleted: '"{title}" notice has been deleted.',
    alertDeleteFail: 'Failed to delete notice.',
    alertTitleRequired: 'Please enter a title.',
    alertContentRequired: 'Please enter content.',
    alertEndAfterStart: 'End date must be after start date.',
    alertCreateSuccess: 'Notice created successfully.',
    alertCreateFail: 'Failed to create notice.',
    alertUpdateSuccess: 'Notice updated successfully.',
    alertUpdateFail: 'Failed to update notice.',
  },
  role: {
    searchPlaceholder: 'Search role name or code...',
    addBtn: 'Add Role',
    loading: 'Loading data...',
    col: {
      name: 'Role Name',
      code: 'Role Code',
      count: 'Permission Count',
      scope: 'Permission Scope',
      description: 'Description',
      action: 'Actions',
    },
    countSuffix: '{n}',
    permissionCount: '({n})',
    permissionSelected: '({n} selected)',
    misc: {
      etcCategory: 'Other',
      noPermissions: 'No permissions configured.',
    },
    detailModal: {
      titleEdit: 'Edit Role Group',
      titleView: 'Role Group Details',
      groupNameLabel: 'Role Group Name',
      groupNamePlaceholder: 'Enter role group name',
      codeLabel: 'Role Code',
      codePlaceholder: 'Enter role code',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Enter description',
      permissionsLabel: 'Permission List',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      close: 'Close',
    },
    deleteModal: {
      title: 'Delete Role Group',
      message: 'Are you sure you want to delete "{name}" role group?\nThis action cannot be undone.',
      confirm: 'Delete',
      cancel: 'Cancel',
    },
    alertLoadFail: 'Failed to load data.',
    alertUpdateSuccess: 'Role group updated.',
    alertUpdateFail: 'Failed to update role group.',
    alertDeleted: '"{name}" role group has been deleted.',
    alertDeleteFail: 'Failed to delete role group. There may be users assigned to this role.',
  },
  roleRegister: {
    title: 'Register Role',
    sectionBasic: 'Basic Information',
    sectionPermissions: 'Permission Settings',
    nameLabel: 'Role Name',
    namePlaceholder: 'Enter role name',
    codeLabel: 'Role Code',
    codePlaceholder: 'e.g. ADMIN, MANAGER',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter role description',
    cancel: 'Cancel',
    submit: 'Register Role',
    alertNameRequired: 'Please enter a role name.',
    alertCodeRequired: 'Please enter a role code.',
    alertCreateSuccess: 'Role registered.',
    alertCreateFail: 'Failed to register role.',
    alertCodeDuplicate: 'This role code is already in use.',
    alertLoadFail: 'Failed to load the permission list.',
    confirmCancel: 'Unsaved changes will be lost. Cancel?',
  },
};

export default user;
